import PropTypes from 'prop-types';
import React from 'react';
import config from 'build-and-quote/config/index.js';

import { IMAGES_BASE_PATH } from 'build-and-quote/constants/accessoryImage.js';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/OptionsResolutions/components/ResolutionHeader/ResolutionHeader.scss';

const ResolutionHeader = ({ paymentFrequencyLabel, showPayments, triggerOption }) => {
    const { description, imageUrl, payment, retail } = triggerOption;
    const imagesServer = config.source.image;

    const optionPayment =
        showPayments && `${LocaleService.l(payment, CurrencyFormats.CURRENCY_2)} ${paymentFrequencyLabel}`;

    const accessoryImage = imageUrl ? (
        <img src={`${imagesServer}${IMAGES_BASE_PATH}/${imageUrl}`} alt={description} />
    ) : (
        <icon className="icon-keyboard_arrow_right is-light" />
    );
    return (
        <div className="optionsResolutions__header">
            <div className="optionsResolutions__header--image">{accessoryImage}</div>
            <div className="optionsResolutions__header--title">{description}</div>
            <div className="optionsResolutions__header--price">
                <span className="is-price">{optionPayment}</span>
                ({LocaleService.l(retail, CurrencyFormats.CURRENCY_0)})
            </div>
        </div>
    );
};

ResolutionHeader.propTypes = {
    paymentFrequencyLabel: PropTypes.string.isRequired,
    showPayments: PropTypes.bool.isRequired,
    triggerOption: PropTypes.shape({
        description: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        payment: PropTypes.number.isRequired,
        retail: PropTypes.number.isRequired,
    }).isRequired,
};

ResolutionHeader.displayName = 'ResolutionHeader';

export default ResolutionHeader;
